import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const AvailabilityIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
  <svg
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    x='0px'
    y='0px'
    viewBox='0 0 485 485'
    style={
      {
        //   enableBackground: 'new 0 0 485 485',
      }
    }
    xmlSpace='preserve'
    {...props}
  >
    <g>
      <path d='M303.352,288.552c12.284,7.049,26.497,11.104,41.648,11.104c46.299,0,83.966-37.667,83.966-83.966 S391.299,131.724,345,131.724c-1.026,0-2.042,0.041-3.059,0.078c-8.594-34.742-27.889-66.241-55.295-89.835 C255.212,14.904,215.03,0,173.5,0C77.832,0,0,77.832,0,173.5C0,269.168,77.832,347,173.5,347c27.81,0,54.381-6.386,78.977-18.979 C271.644,318.206,289.008,304.703,303.352,288.552z M398.966,215.689c0,29.757-24.209,53.966-53.966,53.966 s-53.965-24.209-53.965-53.966s24.208-53.965,53.965-53.965S398.966,185.933,398.966,215.689z M30,173.5 C30,94.374,94.374,30,173.5,30c66.658,0,123.283,44.801,139.146,108.215c-30.283,12.694-51.612,42.637-51.612,77.474 c0,20.347,7.279,39.023,19.364,53.571C253.188,299.751,214.889,317,173.5,317C94.374,317,30,252.626,30,173.5z' />
      <polygon points='158.5,158.346 64.975,158.5 65.025,188.5 188.5,188.296 188.5,65 158.5,65  ' />
      <path d='M345,330c-77.196,0-140,62.804-140,140v15h280v-15C485,392.804,422.196,330,345,330z M236.019,455 c6.666-48.679,45.302-87.311,93.981-93.978V430h30v-68.978c48.678,6.666,87.315,45.298,93.981,93.978H236.019z' />
    </g>
  </svg>
);
export default AvailabilityIcon;
